var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WorkInProgress"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-traffic-cone")]),_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-traffic-cone")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }